<template>
    <TopNav></TopNav>
    <h1>Калкулатор за квадратен корен</h1>
    <fieldset>
        <legend>Калкулатор за квадратен корен</legend>
        <label for="k">Номер: </label><input type="number" v-model.number="inputValue" id="k">
        <br><br>
        Квадратен корен на {{ inputValue }} е <span class="blue">{{ sr }}</span>.
    </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
    name: "SquareRoot",
    data() {
        return {
            sr: 0,
            inputValue: 0
        }
    },
    components: {
        TopNav
    },
    watch: {
        inputValue: function (newValue) {
            this.sr = Math.sqrt(newValue);
        }
    }
};
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}

body {
    margin: 1em auto;
    margin-top: 0;
    max-width: 40em;
    font-family: Arial, Helvetica, sans-serif;
}

label {
    display: inline-block;
    width: 100px;
}

footer section a {
    margin: 20px;
}

.blue {
    color: blue;
}
</style>
